import React, { useEffect, useState } from "react";
import PageHeader from "../../../componentsII/PageHeader";
import CardsStatus from "../../../componentsII/CardStatusRC";
import api from "../../../axios/api";
import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "../../../redux/slices/notificationSlice";
import boiler from "../../../images/boilder.png";
import Loader from "../../../componentsII/Loader";
import { Box, Modal } from "@mui/material";
import { X } from "lucide-react";
import RefrigerantConsumptionDetailModal from "../../../components/RefrigerantConsumption/RefrigerantConsumptionDetailModal";

const NaturalGasConsumption = () => {
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [locations, setLocations] = useState([]);

  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [detailModalData, setDetailModalData] = useState({});
  const [refrigerantTypeOptions, setRefrigerantTypeOptions] = useState([]);

  const { user } = useSelector((state) => state);
  const year = useSelector((state) => state.user.selectedYear);

  const dispatch = useDispatch();

  const fetchNaturalGasConsumption = async () => {
    setIsDataLoading(true);
    try {
      const response = await api.get(`/equipment/companyRefrigerantConsumption?company_id=${user.user?.company?.id}&year_id=${year.id}`);
      if (response.data.equipment) {
        setLocations(response.data.equipment);
      } else {
        dispatch(
          showNotification({
            message: response.data.message,
            type: "error",
          })
        );
        console.log(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsDataLoading(false);
  };


  useEffect(() => {
    fetchNaturalGasConsumption();
  }, []);

  const locationsToInclude = locations.filter(location => location.refrigerant.refrigerant_id !== undefined);

  const locationsToExclude = locations.filter(location => location.refrigerant.refrigerant_id === undefined);

  return (
    <div>
      <PageHeader
        title={`Refrigerant Consumption`}
        text={["Click into each equipment card in the left panel to add your related refrigerant consumption data ","you'll need the type of refrigerant used and the amoount (e.g. 145 kilograms) consumed during your reporting period"]}
        buttonTitle=""
        handleClick={() => {}}
      >
        {isDataLoading ? (
          <div className="w-full h-[200px] flex justify-center items-center">
            <Loader />
          </div>
        ) : locations.length === 0 ? (
          <div className="text-center py-16 bg-gray-50 rounded-lg">
          <img
            src={boiler}
            alt="No Data"
            className="w-80 h-80 mx-auto text-gray-400 mb-4"
          />
          <h3 className="text-xl font-medium text-gray-600 mb-2">
            No Equipments Found
          </h3>
          <p className="text-gray-500">
            Add your first Equipment to get started
          </p>
        </div>
        ) : (
          <CardsStatus
            img={boiler}
            text1={
              <div className="flex items-center">
                <p className="bg-red-200 w-8 h-8 flex justify-center items-center rounded-full mr-4">
                  {locationsToExclude?.length}
                </p>
                Equipment(s) need to have data added
              </div>
            }
            text2={
              <div className="flex items-center">
                <p className="bg-green-200 w-8 h-8 flex justify-center items-center rounded-full mr-4">
                  {locationsToInclude?.length}
                </p>
                Done
              </div>
            }
            data1={locationsToExclude}
            data2={locationsToInclude}
            buttonTitle1="+ Add Data"
            buttonTitle2="Edit Data"
            buttonIClassname="bg-green-600 hover:bg-green-700 text-white border border-green-500 font-medium w-full text-center flex justify-center hover:-translate-y-0"
            buttonIIClassname="bg-gray-50 hover:bg-gray-100 text-gray-900 border border-gray-900 font-medium w-full text-center flex justify-center hover:-translate-y-0"
            buttonClick={(item, isAdd) => {
              setIsDetailModalOpen(true)
              setDetailModalData(item);
            }}
          />
        )}
        <Modal
          open={isDetailModalOpen}
          onClose={() => setIsDetailModalOpen(false)}
          aria-labelledby="add-location-modal-title"
          aria-describedby="add-location-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "55%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: "8px",
              display: "relative",
            }}
          >
            <button
              onClick={() => setIsDetailModalOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
              aria-label="Close"
            >
              <X size={24} />
            </button>
            <RefrigerantConsumptionDetailModal
              detailModalData={detailModalData}
              refetch={fetchNaturalGasConsumption}
              handleCloseMainDetailModal={() => setIsDetailModalOpen(false)}
            />
          </Box>
        </Modal>
      </PageHeader>
    </div>
  );
};

export default NaturalGasConsumption;
